import { getDeviceDate } from "@myvp/shared/src/clock/get-device-date"

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Date
 */
export const parseHttpDateHeader = (
  data: { get(key: string): string | null } | string | null | undefined
): Date => {
  let value: string | null | undefined
  if (typeof data === "string" || data === null || data === undefined) {
    value = data
  } else {
    value = data.get("date")
  }

  const now = getDeviceDate()
  const parsedDate = value ? new Date(value) : now
  return !isNaN(parsedDate.getTime()) ? parsedDate : now
}
